
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hoiantours",
      function () {
        return require("private-next-pages/hoiantours/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hoiantours"])
      });
    }
  